import type { TransactionNote } from "@/types/transaction-note";

/**
 * Mock transaction notes data for demo mode
 */
export const mockTransactionNotes: Record<string, TransactionNote[]> = {
  "1": [
    {
      id: "tnote-1",
      transactionId: "1",
      content: "Payment reminder sent to customer. Invoice is 5 days overdue.",
      createdAt: "2024-01-15T14:30:00Z",
      createdBy: {
        id: "1",
        name: "John Smith",
      },
    },
    {
      id: "tnote-2",
      transactionId: "1",
      content: "Customer acknowledged the invoice and confirmed payment will be processed by end of week.",
      createdAt: "2024-01-12T09:15:00Z",
      createdBy: {
        id: "2",
        name: "Sarah Johnson",
      },
    },
  ],
};

/**
 * Get notes for a specific transaction
 */
export function getTransactionNotes(transactionId: string): TransactionNote[] {
  return mockTransactionNotes[transactionId] || [];
}

/**
 * Add a new note for a transaction (demo mode)
 */
export function addTransactionNote(
  transactionId: string,
  content: string,
  userId: string,
  userName: string
): TransactionNote {
  const newNote: TransactionNote = {
    id: `tnote-${Date.now()}`,
    transactionId,
    content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: userId,
      name: userName,
    },
  };

  if (!mockTransactionNotes[transactionId]) {
    mockTransactionNotes[transactionId] = [];
  }

  mockTransactionNotes[transactionId].unshift(newNote);

  return newNote;
}
